import { render, staticRenderFns } from "./TranHistoryList.vue?vue&type=template&id=837449d0&"
import script from "./TranHistoryList.vue?vue&type=script&lang=js&"
export * from "./TranHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./TranHistoryList.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPullToRefresh,QInput,QIcon,QBtn,QChip,QPagination,QTable,QInnerLoading,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPullToRefresh,QInput,QIcon,QBtn,QChip,QPagination,QTable,QInnerLoading,QTr,QTh,QTd})
